import {
  Component,
  computed,
  EventEmitter,
  inject,
  input,
  Output,
} from '@angular/core';
import { TextInterpolationService } from '@core/jss-utils';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { getPromoCodePlans } from '@innogy/become-a-customer/state';
import { RoundedCurrencyPipe } from '@innogy/utils-deprecated';
import { Store } from '@ngrx/store';
import { DefaultComponentModule } from '@innogy/core/modules/components';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { CrntButtonAlt, CrntIcon } from '@essent/current-web-angular';

import {
  CommodityOfferLabels,
  CommodityOfferLayoutType,
} from '../../commodity-offers.model';
import { CommodityOfferCardComponent } from '../../commodity-offer-card/commodity-offer-card.component';
import { CommodityOfferEssentHeaderComponent } from '../../partials/essent/commodity-offer-header/commodity-offer-header.component';
import { CommodityOfferAccordionComponent } from '../../commodity-offer-accordion/commodity-offer-accordion.component';
import { CommodityOfferViewTariffsComponent } from '../../partials/shared/commodity-offer-view-tariffs/commodity-offer-view-tariffs.component';
import { CommodityOfferEssentProductBreakdownComponent } from '../../partials/essent/commodity-product-breakdown/commodity-product-breakdown.component';
import { CommodityVerticalOfferDropdownComponent } from '../../partials/ed/commodity-vertical-offer-dropdown/commodity-vertical-offer-dropdown.component';
import { CommodityOfferPriceTagComponent } from '../../partials/shared/commodity-offer-price-tag/commodity-offer-price-tag.component';

@Component({
  selector: 'essent-consumer-acquisition-commodity-offer',
  templateUrl: './essent-consumer-acquisition-commodity-offer.component.html',
  standalone: true,
  imports: [
    CommodityOfferCardComponent,
    CommodityOfferEssentHeaderComponent,
    CommodityOfferAccordionComponent,
    DefaultComponentModule,
    CommodityOfferViewTariffsComponent,
    CommodityOfferEssentProductBreakdownComponent,
    CommodityVerticalOfferDropdownComponent,
    CommodityOfferPriceTagComponent,
    CSCaptureDirective,
    CrntButtonAlt,
    CrntIcon,
    RoundedCurrencyPipe,
  ],
})
export class EssentConsumerAcquisitionCommodityOfferComponent {
  readonly offer = input<Offer>();
  readonly content = input<CommodityOfferLabels>();
  readonly variant = input<CommodityOfferLayoutType>();
  readonly active = input(false);
  readonly showMemberGetMember = input(false);
  readonly showLoadingState = input(false);
  readonly ensureHorizontalAlignment = input(false);
  readonly hideCommodityProductBreakdownTable = input(false);
  readonly useAlternateCommodityTariffView = input(false);
  readonly centerAlignedTariffLink = input(false);
  readonly showTariffs = input(false);
  readonly enableNewOfferCardTitles = input(false);
  readonly termijnbedragVariantA = input(false);
  readonly termijnbedragVariantB = input(false);

  @Output() selectOffer = new EventEmitter<void>();
  @Output() openMoreInfo = new EventEmitter<void>();
  @Output() viewTariffs = new EventEmitter<void>();
  @Output() openTariffDropdown = new EventEmitter<void>();
  @Output() closeTariffDropdown = new EventEmitter<void>();

  readonly store$ = inject(Store);
  readonly interpolationService = inject(TextInterpolationService);
  readonly currencyPipe = inject(RoundedCurrencyPipe);

  readonly promoCodePlans = this.store$.selectSignal(getPromoCodePlans);
  readonly promoCodeBadge = computed(() => {
    const promoCodeAmount = this.promoCodePlans()?.find(
      (plan) => plan.duration === this.offer()?.duration
    )?.amount;
    const label = this.content()?.promoCodeLabel;

    let badge;
    if (promoCodeAmount && label) {
      const amount = this.currencyPipe.transform(
        promoCodeAmount,
        'EUR',
        'symbol',
        '1.0-2'
      );
      badge = this.interpolationService.interpolate(
        label,
        { amount },
        'plain_text'
      );
    }

    return badge;
  });
}
